module.exports = __webpack_public_path__ + "images/slqlite-talk-is-cheap.webp";